import { factboxSingleMetricStoryboardComponentSettings } from '../factbox-single-metric/settings';
import { factboxTwoMetricStoryboardComponentSettings } from '../factbox-two-metric/settings';
import { overTimeSegmentedStoryboardComponentSettings } from '../over-time-segmented/settings';
import { overTimeUnsegmentedStoryboardComponentSettings } from '../over-time-unsegmented/settings';
import { timePeriodSegmentedStoryboardComponentSettings } from '../time-period-segmented/settings';
import { timePeriodUnsegmentedStoryboardComponentSettings } from '../time-period-unsegmented/settings';
import { StoryboardComponentSettings } from './types';

export const storyboardComponentSettings = [
  timePeriodSegmentedStoryboardComponentSettings,
  timePeriodUnsegmentedStoryboardComponentSettings,
  overTimeSegmentedStoryboardComponentSettings,
  overTimeUnsegmentedStoryboardComponentSettings,
  factboxSingleMetricStoryboardComponentSettings,
  factboxTwoMetricStoryboardComponentSettings,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
] satisfies ReadonlyArray<StoryboardComponentSettings<any, any>>;
